
import axios from "axios";

const DOMAIN = "https://face.equlix.com"; // Change if deployed
const API_KEY = "ed393afc-02ae-4dee-bb3e-d8e3a30415ed"; // Use verification service key

const compreface = axios.create({
  baseURL: `${DOMAIN}/api/v1/verification`,
  headers: {
    "x-api-key": API_KEY,
  },
});

export default compreface;